import styled from 'styled-components';
import { palette } from 'styled-theme';

export const TypeMovementTag = styled.span`
  width: 60px;
  height: 20px;
  padding: 0 5px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  background-color: ${palette('error', 0)};
  font-size: 12px;
  color: #ffffff;
  text-transform: capitalize;

  &.Entrada {
    background-color: ${palette('success', 0)};
  }
`;

export const StatusTag = styled.span`
  padding: 0 5px;
  height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  background-color: ${palette('primary', 0)};
  font-size: 12px;
  color: #ffffff;
  text-transform: capitalize;

  &.Inativo {
    background-color: ${palette('alert', 0)};
  }

  &.Ativo {
    background-color: ${palette('primary', 0)};
  }
`;
